import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const sidiousPlugin = createPlugin({
  id: 'sidious',
  routes: {
    root: rootRouteRef,
  },
});

export const SidiousPage = sidiousPlugin.provide(
  createRoutableExtension({
    name: 'SidiousPage',
    component: () => import('./components/MainPage').then(m => m.MainPage),
    mountPoint: rootRouteRef,
  }),
);
